import { LwButton, Toolbox } from 'redesign';
import { useNavigate } from 'react-router-dom';
import { IconCancel } from 'assets/img';
import { hqRoutes } from 'hq/Routes';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { PartnersFilterParams } from '../../partners/partners.types';

export const PartnerToolbox = ({ params }: { params: PartnersFilterParams }) => {
  const navigate = useNavigate();
  const generatePath = useHqRelativePath();

  const redirectPath = generatePath(hqRoutes.Partners, {}, { searchFilter: params.searchFilter });

  return (
    <Toolbox>
      <LwButton
        onClick={() => {
          navigate(redirectPath);
        }}
        color="secondary"
        iconColorMode="fill"
        startIcon={<IconCancel />}
      >
        Terug
      </LwButton>
    </Toolbox>
  );
};
